module.exports = __webpack_public_path__ + "img/packing-4.c4ee7cb5.png";